import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../../config';

const fmt = (n) => (n ?? 0).toLocaleString('it-IT');

export default function TabTerritorio({
  regioni, province, obiettivi,
  esito, setEsito, showToWork, setShowToWork,
  selRegioni, setSelRegioni, selProvince, setSelProvince,
  onReloadObiettivi, goExport,
}) {
  const [openReg, setOpenReg] = useState(null);

  const prioKeys = new Set(
    (obiettivi || []).filter((o) => o.stato === 'attivo').map((o) => `${o.tipo}:${o.nome}`)
  );
  const regPrio = new Set([...prioKeys].filter((k) => k.startsWith('regione:')).map((k) => k.slice(8)));
  const provPrio = new Set([...prioKeys].filter((k) => k.startsWith('provincia:')).map((k) => k.slice(10)));

  const provShown = openReg ? province.filter((p) => p.regione === openReg) : province;

  const toggle = (setFn, nome) => setFn((prev) => {
    const n = new Set(prev);
    if (n.has(nome)) n.delete(nome); else n.add(nome);
    return n;
  });

  const sendPriority = async (tipo, nome) => {
    try {
      const r = await axios.post(`${API}/obiettivi/verifica-completa`, { aree: [{ tipo, nome }] });
      const { creati, limite_raggiunto, saltati } = r.data || {};
      if (creati) toast.success(`${nome} in priorità 456`);
      else if (limite_raggiunto) toast.error('Limite priorità 456 raggiunto');
      else if (saltati && saltati.length) toast(`${nome} è già in coda`);
      onReloadObiettivi?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const tv = (v) => (esito === 'non' ? '·' : fmt(v));
  const nv = (v) => (esito === 'tim' ? '·' : fmt(v));

  return (
    <div>
      <div className="xhub-toolbar">
        <div className="xhub-seg">
          {[['all', 'Tutti'], ['tim', 'TIM'], ['non', 'NON TIM']].map(([id, lbl]) => (
            <button key={id} type="button" className={esito === id ? 'on' : ''} onClick={() => setEsito(id)}>{lbl}</button>
          ))}
        </div>
        <label className="xhub-switch">
          <input type="checkbox" checked={showToWork} onChange={(e) => setShowToWork(e.target.checked)} />
          Mostra anche aree da lavorare
        </label>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 10, alignItems: 'center' }}>
          <b>{selRegioni.size + selProvince.size} selezionate</b>
          <button className="btn btn-primary" onClick={goExport}>Manda all'Export</button>
        </div>
      </div>

      {!showToWork && regioni.length === 0 && (
        <div className="card" style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
          Nessuna area pronta all'export con i criteri attuali. Attiva "Mostra anche aree da lavorare" per vederle tutte.
        </div>
      )}

      <div className="xhub-terr">
        <div className="card">
          <h2>Regioni</h2>
          <table>
            <thead><tr><th>Area</th><th>TIM</th><th>NON TIM</th><th>Da fare</th><th>Avanz.</th><th>★</th></tr></thead>
            <tbody>
              {regioni.map((r) => (
                <tr key={r.nome} className={openReg === r.nome ? 'open' : ''}
                  onClick={() => setOpenReg((p) => (p === r.nome ? null : r.nome))} style={{ cursor: 'pointer' }}>
                  <td>
                    <input type="checkbox" checked={selRegioni.has(r.nome)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => toggle(setSelRegioni, r.nome)} />{' '}
                    {r.nome}{regPrio.has(r.nome) && <span className="xhub-prio">PRIO</span>}
                  </td>
                  <td className="tim">{tv(r.tim)}</td>
                  <td className="non">{nv(r.non_tim)}</td>
                  <td className="wait">{fmt(r.pending)}</td>
                  <td>
                    <span className="xhub-pbar"><i style={{ width: `${r.tot ? Math.round(r.controllati / r.tot * 100) : 0}%` }} /></span>
                  </td>
                  <td>
                    <button className="xhub-star" title="Priorità 456"
                      onClick={(e) => { e.stopPropagation(); sendPriority('regione', r.nome); }}>★</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="card">
          <h2>{openReg ? `Province — ${openReg}` : 'Province — tutte'}</h2>
          <table>
            <thead><tr><th>Area</th><th>Caricati</th><th>TIM</th><th>NON TIM</th><th>Da fare</th><th>Pronti</th><th>Avanz.</th><th>★</th></tr></thead>
            <tbody>
              {provShown.map((p) => (
                <tr key={p.nome} className={selProvince.has(p.nome) ? 'sel' : ''}>
                  <td>
                    <input type="checkbox" checked={selProvince.has(p.nome)}
                      onChange={() => toggle(setSelProvince, p.nome)} /> {p.nome}
                    {provPrio.has(p.nome) && <span className="xhub-prio">PRIO</span>}
                  </td>
                  <td>{fmt(p.tot)}</td>
                  <td className="tim">{tv(p.tim)}</td>
                  <td className="non">{nv(p.non_tim)}</td>
                  <td className="wait">{fmt(p.pending)}</td>
                  <td>{p.esportabili ? fmt(p.esportabili) : '—'}</td>
                  <td>
                    <span className="xhub-pbar"><i style={{ width: `${p.tot ? Math.round(p.controllati / p.tot * 100) : 0}%` }} /></span>
                  </td>
                  <td>
                    <button className="xhub-star" title="Priorità 456"
                      onClick={() => sendPriority('provincia', p.nome)}>★</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
